module.exports = __webpack_public_path__ + "media/images/small-arrow-1c1400fd.svg";